import { CashierPosPage } from './CashierPosPage';
import { useSingleStationMode } from './useSingleStationMode';

import { SingleStationPosPage } from '@/modules/cashier-pos/single-station/SingleStationPosPage';

/**
 * Picks the cashier POS layout by rendering ONE of two full component trees — never a
 * mid-function early return inside either page, which would violate rules-of-hooks if
 * `single_station_mode` changes between renders (both pages call ~10-30 hooks each).
 * `CashierPosPage` (two-station queues + inline single-station branch) stays untouched
 * for multi-station clinics; `SingleStationPosPage` is the traditional-POS single window
 * used only when `pos.single_station_mode_enabled` is on for the current dual-role user.
 */
export function CashierPosGate(): JSX.Element {
  const single_station_mode = useSingleStationMode();
  return single_station_mode ? <SingleStationPosPage /> : <CashierPosPage />;
}
